import { jsxs, jsx } from 'react/jsx-runtime';
import { wrapperStyle, labelStyle } from '../styles.js';
var StubbedWrapper = function StubbedWrapper(_ref) {
  var children = _ref.children;
  return jsxs("section", {
    "data-testid": "stubbed-wrapper",
    style: wrapperStyle,
    children: [jsx("div", {
      style: labelStyle,
      children: "Stubbed Payment"
    }), children]
  });
};
export { StubbedWrapper as default };